import { Component, OnDestroy, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { IAudit, IAccount } from '../../../../interfaces/graph-types';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { PaginationTemplate } from '../../../../interfaces/pagination';
import { ActivatedRoute } from '@angular/router';
import { UtilityService } from '../../../../services/utility.service';

@Component({
  selector: 'account-audit',
  template: require('./account-audit.component.pug'),
  styles: [require('./account-audit.component.css').toString()],
})
export class AccountAuditComponent implements OnDestroy, OnInit {
  // -------------------------------------------------------------------
  constructor(
    private watchAcccount: WatchAccountService,
    private utilityService: UtilityService,
    private datePipe: DatePipe,
    private apollo: Apollo,
    private route: ActivatedRoute,
  ) {
    this.scopeIcons = this.utilityService.auditScopeIcons();
  }

  //changes$: Observable<IAudit[]>;
  auditPagination: PaginationTemplate<IAudit>;

  sub: any = null;
  itemPerPage = 60; // set to 60 in account type > audits field definition
  maxSize = 10;
  currentPage: number = 1;

  scopeIcons: any = {};

  emptySearchFilter = {
    logon_id: null,
    mutation_types: [],
    created_before: null,
    created_after: null,
    textSearch: null,
  };
  searchFilter = this.emptySearchFilter;

  // -------------------------------------------------------------------
  buildQuery() {
    let a = this.apollo.watchQuery<{ account: IAccount }>({
      query: gql`
        query accountAuditPagination(
          $first: Int
          $last: Int
          $after: String
          $before: String
          $skip: Int
          $accountId: ID!
          $searchFilter: String
        ) {
          account(accountId: $accountId) {
            id
            audits(
              first: $first
              last: $last
              after: $after
              before: $before
              skip: $skip
              searchFilter: $searchFilter
            ) {
              totalCount
              pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
              }
              edges {
                node {
                  id
                  author {
                    id
                    name
                    email
                    avatarUrl(size: 48)
                  }
                  name
                  scope
                  createdAt
                  duration
                  error
                }
              }
            }
          }
        }
      `,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: false,
    });

    return a;
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    let query = this.buildQuery();

    this.sub = this.watchAcccount.accountId().subscribe(account_id => {
      this.auditPagination = new PaginationTemplate<IAudit>(
        this.apollo,
        account_id,
        query,
        'account',
        'audits',
        null,
        null,
        this.searchFilter,
      );
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }

  // -------------------------------------------------------------------
  pageChanged(page: number): void {
    this.currentPage = page;
    // Load page
    this.auditPagination.setOffset((page - 1) * this.itemPerPage);
  }

  //previous = { day: null, createdAt: null };

  // -------------------------------------------------------------------
  diffDay(first, second) {
    return (
      this.datePipe.transform(first.createdAt) !=
      this.datePipe.transform(second.createdAt)
    );
    /*
    if (change.day == null) {
      change.day = this.datePipe.transform(change.createdAt);
    }
    if (this.previous.day == null) {
      this.previous.day = this.datePipe.transform(this.previous.createdAt);
    }
    let diff = change.day != this.previous.day;

    this.previous = change;

    return diff;
    */
  }

  // -------------------------------------------------------------------
  onUpdateFilter(filter = this.emptySearchFilter) {
    this.searchFilter = filter;
    this.auditPagination.searchFilter = this.searchFilter;

    this.auditPagination.refresh();
  }
}
